import { render } from "./ScanView.vue?vue&type=template&id=0f565c9f&scoped=true"
import script from "./ScanView.vue?vue&type=script&lang=js"
export * from "./ScanView.vue?vue&type=script&lang=js"

import "./ScanView.vue?vue&type=style&index=0&id=0f565c9f&lang=scss&scoped=true"

import exportComponent from "E:\\Program\\Python\\crm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f565c9f"]])

export default __exports__